import { render, staticRenderFns } from "./OrderItemComments.vue?vue&type=template&id=4123bf62"
import script from "./OrderItemComments.vue?vue&type=script&lang=js"
export * from "./OrderItemComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports